// removed by extract-text-webpack-plugin
module.exports = {"sec":"Dynamics__sec__245XTuFG","red":"Dynamics__red__1koj3Cs9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dynamics/Dynamics.scss
// module id = mt4q
// module chunks = 0